import { createFileRoute } from "@tanstack/react-router";
import { GuildOverview } from "@/components/guilds";
import { useGuildDetails } from "@/hooks/use-guild-details";
import { usePageTitle } from "@/hooks/use-page-title";

export const Route = createFileRoute("/dashboard/guilds/$applicationGuildId/")({
  component: GuildOverviewPage,
});

function GuildOverviewPage() {
  const { applicationGuildId } = Route.useParams();
  const { discordGuild, enrichedGuild } = useGuildDetails(applicationGuildId);
  const resolvedGuild = discordGuild ?? enrichedGuild;
  usePageTitle(resolvedGuild ? `${resolvedGuild.name} Overview` : "Overview");

  if (!resolvedGuild) {
    return null;
  }

  return <GuildOverview guild={resolvedGuild} />;
}
